import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _QuestionFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-8 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 5a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2h.094C13.147 7 14 7.853 14 8.906v.513c0 .514-.329.97-.816 1.132A3.19 3.19 0 0 0 11 13.581V16h2v-2.419c0-.514.329-.97.816-1.132A3.19 3.19 0 0 0 16 9.419v-.513A3.906 3.906 0 0 0 12.094 5z", clipRule: "evenodd" }) }) });
}
const QuestionFill = forwardRef(_QuestionFill);
export { QuestionFill };
